import axios from 'axios';
import catchError from '@/api/interceptors/format-error';
import {
  displayMessagesOnErrorInterceptor,
  displayMessagesOnSuccessInterceptor,
} from '@/api/interceptors/display-messages-from-api';

const $http = axios.create();
$http.interceptors.response.use(displayMessagesOnSuccessInterceptor, displayMessagesOnErrorInterceptor);
$http.interceptors.response.use(
  response => ({
    ...response.data,
    ...(response.data.response || {}),
  }),
  (error) => {
    if (error.response.status === 401) {
      throw error;
    }
    // Is not a 401, continue on standard catch
    catchError(error);
  },
);

const login = payload => $http.post('/api/login', payload);
const keycloakLogin = payload => $http.post('/api/keycloak/login', payload);
const logout = payload => $http.post('/api/logout', payload);
const googleLogin = payload => $http.post('/api/google/login', payload);
const changePassword = payload => $http.post('/api/changePassword', payload);
const requestPasswordRecovery = ({ email }) => $http.post('/api/auth/forgot-password', { email });
const recoverPassword = ({ jwt, newPassword }) => $http.post('/api/auth/recover-password', { jwt, newPassword });
const requestSecondFactorReset = () => $http.post('/api/auth/two-factor/reset');
const configureSecondFactor = ({ jwt, otp }) => $http.post('/api/auth/two-factor/configure', { jwt, otp });
const verifySecondFactor = ({ jwt, otp }) => $http.post('/api/auth/two-factor/login', { jwt, otp });
const invalidateStaffCredentials = staffId => $http.post('/api/staff/invalidate-credentials', { staffId });

export default {
  login,
  logout,
  googleLogin,
  keycloakLogin,
  changePassword,
  requestPasswordRecovery,
  recoverPassword,
  requestSecondFactorReset,
  configureSecondFactor,
  verifySecondFactor,
  invalidateStaffCredentials,
};
